<template>
  <Container type="card-full">
    <div slot="header">
      <menu-btn :menuid="menuid" @btnClick="btnClick" :btnLoading="btnLoading"></menu-btn>
    </div>
    <vggrid ref="xGrid" :list="list" tableheight="700" flexname=""
            :cols="cols" :showfooter="false" :showPage="true" :resizable="true" :total="query.total"
            :needBlackRow="false"
            @cellClick="cellClick"  @cellDblClick="cellDblClick" @pagechange="pagechange">
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'podIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        doctid: this.$route.query.doctid,
        list: [],
        btnLoading: false,
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'podno', fieldtype: 'C', title: '单号',calculExpr:''},
          { field: 'poddate', fieldtype: 'C', title: '日期',calculExpr:'',formatter:['toDateString', 'yyyy-MM-dd']},
          { field: 'cvname', fieldtype: 'C', title: '供应商',calculExpr:''},
          { field: 'docstatcheckstatusname', fieldtype: 'C', title: '状态',calculExpr:''},
          { field: 'docstatnextcheckdesc', fieldtype: 'C', title: '下一处理',calculExpr:''},
          { field: 'podremark', fieldtype: 'C',title: '备注',calculExpr:''}
        ],
        pod: {},
        query: {
          comid: this.$store.getters.loginUser.usercomid,
          total: 0,
          currPage: 1,
          pageSize: 20
        }
      }
    },
    created () {
      this.$on('ADD', () => this.addPod())
      this.$on('CHG', () => this.chgPod())
      this.$on('DEL', () => this.delPod())
      this.$on('CHECK', () => this.checkDoc())
      this.$on('UNCHECK', () => this.unCheckDoc())
      this.$on('CLOSE', () => this.close())
      this.getPageList()
    },
    mounted () {
    },
    watch: {
      async '$route' () {
        this.getPageList()
      }
    },
    components: {MenuBtn,vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      async addPod () {
        let podno = await request({
          url: '/kfgl/doct/genDocno',
          method: "post",
          data: {comid: this.$store.getters.loginUser.usercomid,doctid: this.doctid, genflg: 0}
        })
        this.$router.push({name: 'podForm', params: {form: {podid: 0,doctid:this.doctid, podno: podno,comid: this.$store.getters.loginUser.usercomid,docstatcheckval:1}, type: 1}})
      },
      async chgPod () {
        this.$router.push({name: 'podForm', params: {form: this.pod, type: 2}})
      },
      async delPod () {
        if (this.pod.docstatcheckval !== 1) {
          this.$message.warning('单据已审核，不能删除!')
          return
        }
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/cggl/pod/delPod',
            method: "post",
            data: this.pod
          })
          // console.log(data)
          if (data.issuccess===1) {
            this.getPageList()
            this.$message.success('删除成功！')
          } else {
            this.$message.error('删除失败！（'+data.msg+')')
          }
        })
      },
      async cellClick (row) {
        this.pod = row.row
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async cellDblClick (row) {
        this.pod = row.row
        this.$router.push({name: 'podForm', params: {form: this.pod, type: 3}})
      },
      async pagechange (podPage) {
        this.query.currPage = podPage.currentPage
        this.query.pageSize = podPage.pageSize
        this.getPageList()
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/cggl/pod/getPageList',
          params: this.query
        })
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      },
      async checkDoc () {
        if (!this.pod.podid) {
          this.$message.warning('请选择一条数据!')
          return
        }
        this.btnLoading = true
        let data = await request({
          url: '/xtgl/docstat/checkDoc',
          method: "post",
          data: {doctid: this.pod.poddoctid,
                  docid: this.pod.podid,
                  doctablename: 'podrec',
                  docidfield: 'podid',
                  fmon: null,
                  userid: this.$store.getters.loginUser.userid}
        })
        // console.log(data)
        if (data.issuccess === 1) {
          await this.getPageList()
          this.btnLoading = false
          this.$message.success(data.msg)
        } else {
          this.btnLoading = false
          this.$message.error('审核失败,'+ data.msg)
        }
      },
      // 反审核
      async unCheckDoc () {
        if (!this.pod.podid) {
          this.$message.warning('请选择一条数据!')
          return
        }
        this.btnLoading = true
        let data = await request({
          url: '/xtgl/docstat/unCheckDoc',
          method: "post",
          data: {doctid: this.pod.poddoctid,
            docid: this.pod.podid,
            doctablename: 'podrec',
            docidfield: 'podid',
            fmon: null,
            userid: this.$store.getters.loginUser.userid}
        })
        if (data.issuccess === 1) {
          await this.getPageList()
          this.btnLoading = false
          this.$message.success(data.msg)
        } else {
          this.btnLoading = false
          this.$message.error('反审核失败,'+ data.msg)
        }
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
